import { SUB_CATEGORIES, NESTED_SUB_CATEGORIES } from '../../types/categories';

const getDisclaimers = (pathfinderWrapper) => ({
    [SUB_CATEGORIES.BUY_VIDEO_TESTIMONIALS]: {
        title: 'gig_page_perseus.disclaimer.spokesperson.title',
        description: 'gig_page_perseus.disclaimer.spokesperson.description'
    },
    [SUB_CATEGORIES.SPIRITUAL_AND_HEALING]: {
        title: 'gig_page_perseus.disclaimer.spiritual_healing.title',
        description: 'gig_page_perseus.disclaimer.spiritual_healing.description'
    },
    [SUB_CATEGORIES.ASTROLOGY_AND_PSYCHICS]: {
        title: 'gig_page_perseus.disclaimer.astrology_psychics.title',
        description: 'gig_page_perseus.disclaimer.astrology_psychics.description'
    },
    [NESTED_SUB_CATEGORIES.CALL_CENTER_AND_CALLING]: {
        title: 'gig_page_perseus.disclaimer.call_center_and_calling.title',
        description: 'gig_page_perseus.disclaimer.call_center_and_calling.description',
        parseMarkup: true,
        i18nParams: { path: pathfinderWrapper.pathfinder('tos') }
    },
    [SUB_CATEGORIES.UNBOXING_VIDEOS]: {
        title: 'gig_page_perseus.disclaimer.unboxing_videos.title',
        description: 'gig_page_perseus.disclaimer.unboxing_videos.description',
        parseMarkup: true,
        i18nParams: { path: `${pathfinderWrapper.pathfinder('community_standards', { slug: 'integrity-authenticity' })}` }
    },
    [SUB_CATEGORIES.CRYPTOCURRENCY]: {
        title: 'gig_page_perseus.disclaimer.cryptocurrency.title',
        description: 'gig_page_perseus.disclaimer.cryptocurrency.description'
    },
    [SUB_CATEGORIES.ONLINE_TUTORING]: {
        title: 'gig_page_perseus.disclaimer.online_tutoring.title',
        description: 'gig_page_perseus.disclaimer.online_tutoring.description',
        parseMarkup: true,
        i18nParams: { path: `${pathfinderWrapper.pathfinder('community_standards', { slug: 'prohibited-services' })}` }
    },
    [SUB_CATEGORIES.RESEARCH_AND_SUMMARIES]: {
        title: 'gig_page_perseus.disclaimer.research_and_summaries.title',
        description: 'gig_page_perseus.disclaimer.research_and_summaries.description',
        parseMarkup: true,
        i18nParams: { path: `${pathfinderWrapper.pathfinder('community_standards', { slug: 'prohibited-services' })}` }
    },
    [NESTED_SUB_CATEGORIES.SEO_FULL_SEO_PACKAGE]: {
        title: 'gig_page_perseus.disclaimer.seo_subcategories.title',
        description: 'gig_page_perseus.disclaimer.seo_subcategories.description'
    },
    [NESTED_SUB_CATEGORIES.SEO_OFF_PAGE_SEO]: {
        title: 'gig_page_perseus.disclaimer.seo_subcategories.title',
        description: 'gig_page_perseus.disclaimer.seo_subcategories.description'
    },
    [NESTED_SUB_CATEGORIES.SEO_ON_PAGE_SEO]: {
        title: 'gig_page_perseus.disclaimer.seo_subcategories.title',
        description: 'gig_page_perseus.disclaimer.seo_subcategories.description'
    },
    [NESTED_SUB_CATEGORIES.SEO_TECHNICAL_SEO]: {
        title: 'gig_page_perseus.disclaimer.seo_subcategories.title',
        description: 'gig_page_perseus.disclaimer.seo_subcategories.description'
    },
    [NESTED_SUB_CATEGORIES.SEO_VOICE_SEARCH_SEO]: {
        title: 'gig_page_perseus.disclaimer.seo_subcategories.title',
        description: 'gig_page_perseus.disclaimer.seo_subcategories.description'
    }
});

export default getDisclaimers;
